import React from 'react'

import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import ReactDOM from 'react-dom/client'
// import TagManager from 'react-gtm-module'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import './index.css'
import './i18n'
import App from './App'
import { appConfig } from './app-config/AppConfig'
import { ErrorBoundaryContainer } from './components/ErrorBoundary'
import { Joyride } from './components/Joyride'
import { JoyrideProvider } from './components/Joyride/JoyrideProvider'
import { Portals } from './components/Portals'
// import reportWebVitals from './reportWebVitals'
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { ScrollToTop } from './components/ScrollToTop'
import { initOtaUpdater } from './ota-update'
import globalStore from './store'
import { StyledContainer } from './StyledContainer'
import { ThemeModeProvider } from './theme/ThemeModeContext'
import { ProvideAuth, UserContextComponent } from './user'

// const tagManagerArgs = {
//   gtmId: 'GTM-W3R2DT9D',
// }
// TagManager.initialize(tagManagerArgs)

async function bootstrap() {
  if (Capacitor.isNativePlatform()) {
    try {
      await CapacitorUpdater.notifyAppReady()
    } catch (err) {}
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    // <React.StrictMode>
    <Provider store={globalStore}>
      <ThemeModeProvider>
        <StyledContainer>
          <Router>
            <UserContextComponent>
              <ErrorBoundaryContainer>
                <ProvideAuth>
                  <JoyrideProvider>
                    <ScrollToTop />
                    <Joyride />
                    <Portals />
                    <App />
                  </JoyrideProvider>
                </ProvideAuth>
              </ErrorBoundaryContainer>
            </UserContextComponent>
          </Router>
        </StyledContainer>
      </ThemeModeProvider>
    </Provider>,
    // </React.StrictMode>,
  )

  if (Capacitor.isNativePlatform() && !appConfig.SKIP_LIVE_UPDATE) {
    void initOtaUpdater(appConfig.OTA_VERSION_URL, appConfig.OTA_ZIP_URL)
  }

  if (Capacitor.isNativePlatform()) {
    await SplashScreen.hide()
  }
}

bootstrap()

// serviceWorkerRegistration.register()

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister()
    })
  })

  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => caches.delete(cacheName))
    })
  }

  // window.location.reload()
}

// reportWebVitals()
